import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status_close",
  "use": "icon-status_close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-status_close\">\n<path d=\"M5.5 5.5L10.5 10.5\" stroke=\"#E5460B\" stroke-linecap=\"round\" />\n<path d=\"M10.5 5.5L5.5 10.5\" stroke=\"#E5460B\" stroke-linecap=\"round\" />\n<circle cx=\"8\" cy=\"8\" r=\"6.5\" stroke=\"#E5460B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol